var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"video-player-container"},[_c('b-embed',{staticClass:"video-frame",attrs:{"type":"iframe","aspect":"16by9","src":_vm.videoUrl,"allowfullscreen":"","title":"Dropsmart Video Content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }